package kz.dentalcrm.app.screens.protocols.add.mvi

import kz.dentalcrm.app.core.base.ViewEvent

sealed interface AddProtocolViewEvent : ViewEvent {

    data class AddProtocol(
        val naming: String,
        val code: String
    ) : AddProtocolViewEvent

    data object Reset : AddProtocolViewEvent
}